(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6066],{

/***/ 26066:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ html; }
});

// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/html/Html.module.scss
var Html_module = __webpack_require__(62192);
var Html_module_default = /*#__PURE__*/__webpack_require__.n(Html_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/html/Html.js






var parseHtmlAndWrapTables = function parseHtmlAndWrapTables(html) {
  return (0,html_react_parser/* default */.ZP)(html || '', {
    replace: function replace(_ref) {
      var name = _ref.name,
          children = _ref.children;

      if (name && name === 'table') {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "table-wrapper",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "table-inner",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("table", {
              children: (0,html_react_parser/* domToReact */.du)(children, {
                replace: function replace(_ref2) {
                  var type = _ref2.type,
                      next = _ref2.next,
                      prev = _ref2.prev;

                  // to avoid warning 'Whitespace text nodes cannot appear as a child of <table>'
                  if (type === 'text') {
                    if (next) {
                      return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                    }

                    if (prev) {
                      return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                    }
                  }
                }
              })
            })
          })
        });
      }
    }
  });
};

var checkScrollPosition = function checkScrollPosition(target) {
  var scrollWidth = target.scrollWidth;
  var scrollLeft = target.scrollLeft;
  var offsetWidth = target.offsetWidth;
  var nextFromStart = scrollLeft > 5;
  var nextReachEnd = scrollWidth - scrollLeft - offsetWidth < 5;
  var prevReachEnd = !target.parentNode.classList.contains('shadow-right');
  var prevFromStart = target.parentNode.classList.contains('shadow-left');

  if (prevReachEnd !== nextReachEnd) {
    target.parentNode.classList.toggle('shadow-right', !nextReachEnd);
  }

  if (prevFromStart !== nextFromStart) {
    target.parentNode.classList.toggle('shadow-left', nextFromStart);
  }
};

var Html = function Html(_ref3) {
  var html = _ref3.html;
  var blockRef = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    var tables = blockRef.current.querySelectorAll('.table-inner');
    var functions = [];

    if (tables.length > 0) {
      tables.forEach(function (table) {
        checkScrollPosition(table, true);

        var fun = function fun() {
          return checkScrollPosition(table);
        };

        table.addEventListener('scroll', fun);
        functions.push(fun);
      });
    }

    return function () {
      if (tables.length > 0) {
        tables.forEach(function (table, ind) {
          table.removeEventListener('scroll', functions[ind]);
        });
      }
    };
  }, [html]);
  var htmlContentComponent = (0,react.useMemo)(function () {
    return parseHtmlAndWrapTables(html);
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    ref: blockRef,
    className: (Html_module_default()).container,
    children: htmlContentComponent
  });
};

/* harmony default export */ var html_Html = (Html);
;// CONCATENATED MODULE: ./components/html/index.js

/* harmony default export */ var html = (html_Html);

/***/ }),

/***/ 62192:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Html_container__N0BcU","align-center":"Html_align-center__XA_lY","ql-align-center":"Html_ql-align-center__0pQXG","align-right":"Html_align-right__z1niC","ql-align-right":"Html_ql-align-right__LorvC","align-justify":"Html_align-justify__7B3Np","ql-align-justify":"Html_ql-align-justify__BYnXo","table-wrapper":"Html_table-wrapper__tHI_v","shadow-left":"Html_shadow-left__vwQAF","shadow-right":"Html_shadow-right__w5Dze","table-inner":"Html_table-inner__S3BPo","align-left":"Html_align-left__6XLBw","load":"Html_load__RA_WG"};

/***/ })

}]);